import _ from 'lodash';
import type { StaffMemberAvailabilityModel } from '@/app/types/availability-slot.type';
import type { StaffMemberListModel } from '@/app/types/staff-member.type';

/**
 * Default staff member sorting: doctors first, then by last name, then by first name
 */
export function sortStaffMembers<T extends StaffMemberListModel | StaffMemberAvailabilityModel>(
  models: T[],
) {
  return _.orderBy(
    models,
    [
      x => selectStaffMember(x).title === 'Dr.',
      x => selectStaffMember(x).lastName,
      x => selectStaffMember(x).firstName,
    ],
    ['desc', 'asc', 'asc'],
  );
}

function selectStaffMember(model: StaffMemberListModel | StaffMemberAvailabilityModel) {
  return 'staffMember' in model ? model.staffMember : model;
}
